// extracted by mini-css-extract-plugin
export default {"genericCard":"hp-z","inline":"ip-z","mastercard":"jp-z","discover":"kp-z","visa":"lp-z","amex":"mp-z","active":"np-z"};